import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "home",
  "use": "home-usage",
  "viewBox": "0 0 15 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 15 16\" id=\"home\">\n<path d=\"M13.4,16H9.8c-0.6,0-1-0.5-1-1v-3.7c0-0.5-0.4-0.8-0.8-0.8H6.4c-0.4,0-0.8,0.4-0.8,0.8V15c0,0.6-0.4,1-1,1H1\n\tc-0.6,0-1-0.5-1-1V7.1c0-0.9,0.4-1.8,1.1-2.4l5.7-4.6C7,0,7.4,0,7.6,0.1l5.7,4.6c0.7,0.6,1.1,1.5,1.1,2.4V15\n\tC14.4,15.5,14,16,13.4,16z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol